"use client"

import React, { useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { api } from "../../../services/Axios"
import Loader from "../../utils/loader/Loader"
import Notification from "../../utils/avisos/Notification"
import PasswordInput from "../../ui/PasswordInput"
import Button from "../../ui/Button"
import { KeyRound, LogIn, CheckCircle } from "lucide-react"

const ResetPassword = () => {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()

  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.")
      return
    }
    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.")
      return
    }
    setError("")
    setIsLoading(true)

    try {
      const response = await api.post(`/api/auth/reset-password/${token}`, { password })
      setSuccess(response.data.msg)
    } catch (err: any) {
      setError(err.response?.data?.msg || "Ocurrió un error. El enlace puede haber expirado.")
    } finally {
      setIsLoading(false)
    }
  }

    if (success) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
            <div className="w-full max-w-md text-center bg-white p-8 md:p-12 rounded-2xl shadow-xl transition-all animate-fade-in">
                
                {/* 1. Icono de Éxito Grande y Amigable */}
                <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
                <CheckCircle className="h-12 w-12 text-green-600" strokeWidth={1.5} />
                </div>

                {/* 2. Título Claro y Positivo */}
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
                ¡Contraseña Actualizada!
                </h2>

                {/* 3. Mensaje de Confirmación */}
                <p className="text-gray-600 mb-8">
                {success}. Ahora puedes ingresar a tu cuenta con tus nuevas credenciales.
                </p>

                {/* 4. Botón de Acción Principal */}
                <Button 
                onClick={() => navigate("/login")}
                size="lg"
                fullWidth
                className="bg-primary hover:bg-primary/90 text-white font-semibold rounded-lg transition-all shadow-md hover:shadow-lg"
                >
                <LogIn className="mr-2 h-5 w-5" />
                Ir a Iniciar Sesión
                </Button>
            </div>
            </div>
        );
    }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      {isLoading && <Loader />}
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
            <img src="/logos/logof.png" alt="Logo" className="h-20 mx-auto mb-4" />
        </div>
        <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-100">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Restablecer Contraseña</h2>
          {error && <Notification message={error} type="error" onClose={() => setError("")} />}
          <form onSubmit={handleSubmit} className="space-y-5">
            <PasswordInput
              label="Nueva Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Escribe tu nueva contraseña"
              fullWidth
            />
            <PasswordInput
              label="Confirmar Nueva Contraseña"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirma tu nueva contraseña"
              fullWidth
            />
            <Button type="submit" fullWidth size="lg" className="mt-6 ...">
               <KeyRound className="mr-2 h-5 w-5" />
               Actualizar Contraseña
            </Button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword